module.exports = __webpack_public_path__ + "static/media/piano_annuale_calcio_juniores.6f7160c9.jpg";